/**
 * @generated SignedSource<<52adda9d061d53138f5c1aa9618a354e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MeaningFailureReason = "RATE_LIMITED" | "UNAVAILABLE" | "UNUSABLE_LANGUAGE" | "%future added value";
export type VocabularyDetailMeaningQuery$variables = {
  id: string;
};
export type VocabularyDetailMeaningQuery$data = {
  readonly me: {
    readonly learner: {
      readonly nativeLanguage: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly node: {
    readonly meaning?: {
      readonly __typename: "Gloss";
      readonly language: string;
      readonly text: string;
    } | {
      readonly __typename: "MeaningFailure";
      readonly reason: MeaningFailureReason;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type VocabularyDetailMeaningQuery = {
  response: VocabularyDetailMeaningQuery$data;
  variables: VocabularyDetailMeaningQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nativeLanguage",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "meaning",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            }
          ],
          "type": "Gloss",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "reason",
              "storageKey": null
            }
          ],
          "type": "MeaningFailure",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VocabularyItem",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VocabularyDetailMeaningQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "VocabularyDetailMeaningQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91264d90bd6feb36f72a903ddeffdba2",
    "id": null,
    "metadata": {},
    "name": "VocabularyDetailMeaningQuery",
    "operationKind": "query",
    "text": "query VocabularyDetailMeaningQuery(\n  $id: ID!\n) {\n  me {\n    learner {\n      nativeLanguage\n      id\n    }\n  }\n  node(id: $id) {\n    __typename\n    ... on VocabularyItem {\n      meaning {\n        __typename\n        ... on Gloss {\n          text\n          language\n        }\n        ... on MeaningFailure {\n          reason\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e15325b8b2e38264241586dfd76eafb";

export default node;
